class AnnouncementBarNewEra extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
    this.prevButton = this.querySelector('[data-announcement-prev]');
    this.nextButton = this.querySelector('[data-announcement-next]');
    this.index = 0;
    this.autoRotateMs = Number(this.dataset.autoRotate) || 5000;
    this.autoRotateTimer = null;

    if (!this.slides.length) return;

    this.prevButton?.addEventListener('click', () => {
      this.show(this.index - 1);
      this.resetAutoRotate();
    });
    this.nextButton?.addEventListener('click', () => {
      this.show(this.index + 1);
      this.resetAutoRotate();
    });

    this.addEventListener('mouseenter', () => this.stopAutoRotate());
    this.addEventListener('mouseleave', () => this.startAutoRotate());
    this.addEventListener('focusin', () => this.stopAutoRotate());
    this.addEventListener('focusout', () => this.startAutoRotate());

    this.show(0);

    if (this.slides.length < 2) {
      this.classList.add('announcement-bar-newera--single');
      this.prevButton?.setAttribute('disabled', 'disabled');
      this.nextButton?.setAttribute('disabled', 'disabled');
      return;
    }

    this.startAutoRotate();
  }

  disconnectedCallback() {
    this.stopAutoRotate();
  }

  show(nextIndex) {
    const targetIndex = (nextIndex + this.slides.length) % this.slides.length;

    this.slides[this.index]?.classList.remove('is-active');
    this.index = targetIndex;
    this.slides[this.index]?.classList.add('is-active');
  }

  startAutoRotate() {
    if (this.slides.length < 2 || this.autoRotateMs <= 0) return;

    this.stopAutoRotate();
    this.autoRotateTimer = window.setInterval(() => {
      this.show(this.index + 1);
    }, this.autoRotateMs);
  }

  stopAutoRotate() {
    if (this.autoRotateTimer) {
      window.clearInterval(this.autoRotateTimer);
      this.autoRotateTimer = null;
    }
  }

  resetAutoRotate() {
    this.stopAutoRotate();
    this.startAutoRotate();
  }
}

customElements.define('announcement-bar-newera', AnnouncementBarNewEra);
